var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgObra = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27475_40600)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27475_40600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.35 0H7.15C3.61538 0 0.75 2.75517 0.75 6.15385V93.8462C0.75 97.2448 3.61538 100 7.15 100H94.35C97.8846 100 100.75 97.2448 100.75 93.8462V6.15385C100.75 2.75517 97.8846 0 94.35 0Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27475_40600)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6812 9.62293C22.6847 9.62293 20.255 11.8905 20.255 14.6875L16.4819 92.5179C16.4819 95.3148 18.9116 97.5818 21.9082 97.5818H112.592C115.589 97.5818 118.019 95.3148 118.019 92.5179L113.166 3.18083C113.166 0.383741 110.736 -1.88379 107.74 -1.88379L25.6812 9.62293Z",
    fill: "#F0F2F1"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7825 104.759L84.0981 88.5193L107.857 88.2485L109.646 104.759",
    fill: "#006B3F"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9358 32.2552C65.2982 31.608 64.7102 30.9135 64.177 30.1778C63.8431 29.7506 63.5558 29.2888 63.3202 28.8003C63.1 28.2891 62.9228 27.7604 62.7904 27.2196L61.8773 23.8889C61.8599 23.8071 61.8599 23.7225 61.8773 23.6405C61.8925 23.5385 61.9422 23.4447 62.0181 23.3748C62.094 23.305 62.1915 23.2633 62.2944 23.2567C62.5069 23.2443 62.7174 23.3039 62.8918 23.4261C63.4154 23.8009 63.8094 24.3297 64.0192 24.939C64.256 25.5148 64.5603 27.5245 65.575 26.8584C65.7278 26.7444 65.8494 26.5935 65.9283 26.4198C66.0071 26.246 66.0407 26.0551 66.0259 25.8648C66.0143 25.4159 65.833 24.9881 65.5186 24.668C65.0677 24.2164 64.3913 24.0358 63.9742 23.5389C63.7657 23.2711 63.6525 22.9414 63.6525 22.6018C63.6525 22.2623 63.7657 21.9325 63.9742 21.6647C63.772 21.3278 63.6786 20.9366 63.7069 20.5445C63.7351 20.1525 63.8836 19.7787 64.132 19.4744C63.9097 19.3188 63.7509 19.0881 63.6846 18.8248C63.6183 18.5615 63.649 18.283 63.7712 18.0405C63.8972 17.8026 64.081 17.6003 64.3056 17.4523C64.5302 17.3044 64.7884 17.2154 65.0564 17.1937C67.469 16.9453 68.957 20.0615 69.6786 21.8905C70.2198 23.7569 71.1154 25.5012 72.3166 27.0277",
    fill: "#C1813E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1941 54.4987L79.7988 38.4534L72.1505 25.0752L63.3574 32.7261L74.8069 49.2304C75.5617 50.3277 76.4797 51.3144 77.5317 52.1597L88.4429 60.9692",
    fill: "url(#paint0_linear_27475_40600)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3029 58.3391L84.3949 59.5359L79.7825 38.7173L96.9541 52.6732",
    fill: "url(#paint1_linear_27475_40600)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3337 1.58907L63.232 33.5237L63.0852 84.4828V96.262C63.1097 96.4712 63.2124 96.6643 63.3738 96.8043C63.5352 96.9443 63.744 97.0212 63.9604 97.0212C64.1768 97.0212 64.3856 96.9443 64.547 96.8043C64.7084 96.6643 64.8111 96.4712 64.8356 96.262L64.8921 64.3824L65.0502 13.4232L65.0841 1.58907C65.0596 1.38007 64.9569 1.18715 64.7954 1.04708C64.634 0.907005 64.4252 0.82959 64.2089 0.82959C63.9925 0.82959 63.7837 0.907005 63.6222 1.04708C63.4609 1.18715 63.3581 1.38007 63.3337 1.58907Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9846 1.53547L42.8942 33.4701L42.7361 84.4295V96.2088C42.7361 96.4357 42.8289 96.6534 42.9941 96.8141C43.1593 96.9749 43.3833 97.0649 43.617 97.0649C43.8506 97.0649 44.0746 96.9749 44.2398 96.8141C44.405 96.6534 44.4978 96.4357 44.4978 96.2088L44.5881 64.2739L44.7462 13.3147V1.53547C44.7462 1.30838 44.6534 1.09058 44.4882 0.929993C44.323 0.769414 44.099 0.679199 43.8654 0.679199C43.6318 0.679199 43.4077 0.769414 43.2426 0.929993C43.0774 1.09058 42.9846 1.30838 42.9846 1.53547Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.623 9.29674L22.5439 36.0717L22.4197 78.512V88.3373C22.4197 88.5643 22.5125 88.782 22.6777 88.9427C22.8429 89.1035 23.0669 89.1935 23.3006 89.1935C23.5342 89.1935 23.7582 89.1035 23.9234 88.9427C24.0886 88.782 24.1814 88.5643 24.1814 88.3373L24.2604 61.5513L24.3846 19.111V9.29674C24.3846 9.06966 24.2918 8.85181 24.1266 8.69128C23.9614 8.53066 23.7374 8.44043 23.5038 8.44043C23.2702 8.44043 23.0462 8.53066 22.881 8.69128C22.7158 8.85181 22.623 9.06966 22.623 9.29674Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M83.638 12.6564L83.446 76.2511V85.3189C83.47 85.5281 83.5732 85.7204 83.7348 85.8612C83.8956 86.0012 84.1044 86.0781 84.3212 86.0781C84.5372 86.0781 84.746 86.0012 84.9076 85.8612C85.0692 85.7204 85.1716 85.5281 85.1964 85.3189L85.3884 21.7131V12.6564C85.3636 12.4474 85.2612 12.2545 85.0996 12.1144C84.938 11.9744 84.7292 11.897 84.5132 11.897C84.2964 11.897 84.0876 11.9744 83.9268 12.1144C83.7652 12.2545 83.662 12.4474 83.638 12.6564Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87747 27.387L42.8073 27.4857L95.3532 27.6284H107.492C107.726 27.6284 107.95 27.5383 108.116 27.3776C108.28 27.2171 108.373 26.9993 108.373 26.7722C108.373 26.5451 108.28 26.3273 108.116 26.1667C107.95 26.0061 107.726 25.9159 107.492 25.9159L74.5627 25.8281L22.0172 25.7183H9.87747C9.66243 25.7421 9.46403 25.842 9.31987 25.9989C9.17579 26.1558 9.09619 26.3587 9.09619 26.5691C9.09619 26.7794 9.17579 26.9824 9.31987 27.1393C9.46403 27.2963 9.66243 27.3961 9.87747 27.4199V27.387Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7793 63.1103L31.4468 63.1871L75.5904 63.2859H85.7541C85.9692 63.2621 86.1677 63.1623 86.3117 63.0054C86.4557 62.8484 86.5349 62.6454 86.5349 62.4351C86.5349 62.2247 86.4557 62.0218 86.3117 61.8649C86.1677 61.708 85.9692 61.6081 85.7541 61.5844L58.0978 61.5075L13.988 61.4307H3.82448C3.60949 61.4544 3.41103 61.5543 3.26694 61.7112C3.12284 61.8681 3.04321 62.0711 3.04321 62.2814C3.04321 62.4917 3.12284 62.6947 3.26694 62.8517C3.41103 63.0086 3.60949 63.1084 3.82448 63.1322L3.7793 63.1103Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.52 80.9616L40.1875 81.0378L84.3308 81.1585H94.4948C94.7284 81.1585 94.9524 81.0685 95.1172 80.9078C95.2828 80.7478 95.3756 80.5293 95.3756 80.3024C95.3756 80.0755 95.2828 79.8578 95.1172 79.697C94.9524 79.5362 94.7284 79.4462 94.4948 79.4462L66.8272 79.3693L22.6836 79.2485H12.52C12.2864 79.2485 12.0624 79.3385 11.8972 79.4993C11.732 79.6601 11.6392 79.8778 11.6392 80.1047C11.6392 80.3324 11.732 80.5501 11.8972 80.7101C12.0624 80.8708 12.2864 80.9616 12.52 80.9616Z",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44948 45.2374L36.8108 45.3253L83.9468 45.457H94.7316C94.9468 45.4332 95.1452 45.3334 95.2892 45.1764C95.4332 45.0195 95.5132 44.8165 95.5132 44.6062C95.5132 44.3959 95.4332 44.1929 95.2892 44.036C95.1452 43.8791 94.9468 43.7792 94.7316 43.7554L65.3704 43.6676L18.268 43.5249H7.44948C7.23449 43.5487 7.03603 43.6485 6.89194 43.8054C6.74785 43.9624 6.66821 44.1654 6.66821 44.3757C6.66821 44.586 6.74785 44.789 6.89194 44.9459C7.03603 45.1028 7.23449 45.2027 7.44948 45.2264V45.2374Z",
    fill: "#AC41D8"
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3045 86.8149L52.9006 86.9942C51.0398 87.0896 49.2131 87.258 47.3524 87.3534C46.9325 87.3534 46.3766 87.5219 46.3766 87.9119C46.3916 88.018 46.4347 88.1188 46.5021 88.2057C46.5694 88.2919 46.6589 88.3619 46.7624 88.408C47.2807 88.6426 47.8361 88.7996 48.4076 88.8719C48.6921 88.9134 48.9617 89.0188 49.1929 89.1788C49.4241 89.3388 49.6101 89.548 49.735 89.7896C49.7982 90.1119 49.7538 90.4442 49.6077 90.7419C49.4617 91.0396 49.221 91.2888 48.9181 91.4557C48.3281 91.8234 47.6559 92.0619 46.9524 92.1534C46.2488 92.2449 45.5321 92.1865 44.8562 91.9834C44.4857 91.8811 44.106 91.8103 43.7216 91.7726C43.5344 91.7572 43.3458 91.7803 43.1693 91.8411C42.9929 91.9011 42.8329 91.9965 42.7005 92.1203C42.5535 92.3265 42.4686 92.5649 42.4547 92.8119C42.4407 93.0588 42.4981 93.3042 42.621 93.5234C42.9957 94.2896 43.5566 94.9649 44.2594 95.4957C44.9623 96.0265 45.788 96.398 46.6716 96.5819C50.3591 97.4996 54.6139 95.9911 58.1312 94.8842",
    fill: "#C1813E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0604 59.5347L87.6148 52.8367C86.302 52.1659 85.1796 51.7547 83.9228 51.0297C83.1228 50.6706 82.4764 50.0549 82.094 49.2876C81.9964 48.8145 81.998 48.3271 82.1004 47.8548C82.2028 47.3826 82.4028 46.935 82.6884 46.5392C83.3284 45.3705 84.0236 44.2236 84.7756 43.109C84.2148 42.7519 83.586 42.2433 83.654 41.5941C83.7212 40.9449 84.2148 40.7609 84.6636 40.512L87.9508 38.5319C88.8364 37.9282 89.8028 37.4439 90.8236 37.0927C91.3956 36.9322 91.9812 36.82 92.574 36.7573C94.13 36.4403 95.7444 36.5111 97.2636 36.9629C98.3772 37.3047 99.3636 37.9513 100.103 38.824C100.76 39.7807 101.188 40.8667 101.355 42.0029C101.521 43.1392 101.424 44.2971 101.068 45.3922C100.336 47.5829 99.0516 49.5644 97.3316 51.1596L99.7996 56.3859",
    fill: "#C1813E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6221 42.3052C87.8277 42.3052 87.9949 42.1446 87.9949 41.9463C87.9949 41.7481 87.8277 41.5874 87.6221 41.5874C87.4157 41.5874 87.2485 41.7481 87.2485 41.9463C87.2485 42.1446 87.4157 42.3052 87.6221 42.3052Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4604 45.0841C84.7284 45.2561 85.0316 45.3705 85.3492 45.4197C85.666 45.4689 85.9908 45.4516 86.3012 45.3692C86.3564 45.3532 86.4028 45.3165 86.4308 45.2672C86.458 45.2178 86.4644 45.1598 86.4476 45.106C86.4316 45.0522 86.3932 45.0069 86.3428 44.9802C86.2916 44.9535 86.2324 44.9475 86.1772 44.9634C85.9212 45.0319 85.6524 45.0448 85.3916 45.0012C85.13 44.9575 84.8812 44.8585 84.6636 44.7112C84.438 44.5576 84.2348 44.9305 84.4604 45.0841Z",
    fill: "#C1813E"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9141 53.504L82.3461 58.2327C81.0637 58.7187 79.9232 59.4953 79.02 60.4966C78.1169 61.4979 77.4784 62.6943 77.1585 63.984L74.8734 73.1883C74.6467 74.1088 74.2254 74.9745 73.6356 75.7314C73.0459 76.4882 72.3004 77.1196 71.4456 77.5873L54.3982 86.6158L58.9686 96.8642L82.7341 86.0988L82.3005 93.3896L108.9 93.1696V78.8735C108.922 70.9907 106.879 63.2295 102.958 56.3082C102.201 54.9798 100.966 53.9625 99.4853 53.4465C98.0053 52.9304 96.3805 52.9508 94.9141 53.504Z",
    fill: "#00D38D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9141 53.504L82.3461 58.2327C81.0637 58.7187 79.9232 59.4953 79.02 60.4966C78.1169 61.4979 77.4784 62.6943 77.1585 63.984L74.8734 73.1883C74.6467 74.1088 74.2254 74.9745 73.6356 75.7314C73.0459 76.4882 72.3004 77.1196 71.4456 77.5873L54.3982 86.6158L58.9686 96.8642L82.7341 86.0988L82.3005 93.3896L108.9 93.1696V78.8735C108.922 70.9907 106.879 63.2295 102.958 56.3082C102.201 54.9798 100.966 53.9625 99.4853 53.4465C98.0053 52.9304 96.3805 52.9508 94.9141 53.504Z",
    fill: "url(#paint2_linear_27475_40600)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7357 50.3456C100.485 49.3486 101.221 48.3742 102.04 47.4565C102.819 46.6136 103.373 45.5936 103.653 44.488C103.681 44.1753 103.681 43.8605 103.653 43.5476C103.652 42.1506 103.127 40.803 102.177 39.7635C101.203 38.5902 99.9429 37.6782 98.5141 37.1123C97.4429 36.7044 96.2909 36.5345 95.2653 35.9793C93.5725 35.1409 92.1901 33.8153 90.3813 33.1809C89.9613 32.9999 89.4989 32.9348 89.0445 32.9927C88.5901 33.0506 88.1597 33.2293 87.8005 33.5094C87.5341 33.7874 87.3549 34.135 87.2829 34.5106C87.2117 34.8862 87.2517 35.2741 87.3973 35.6281C88.1925 37.6675 92.6621 37.8941 92.3629 40.6019C92.2461 41.0806 92.0557 41.5391 91.7981 41.9615C91.6701 42.17 91.6021 42.409 91.6021 42.6526C91.6021 42.8963 91.6701 43.1352 91.7981 43.3437C91.9333 43.4737 92.0973 43.571 92.2773 43.628C92.4573 43.685 92.6485 43.7002 92.8349 43.6723C93.3765 43.6723 93.9869 43.2984 94.5285 43.5023C94.8597 43.6506 95.1349 43.898 95.3149 44.2093C95.4949 44.5206 95.5709 44.8799 95.5309 45.2358C95.4797 45.5931 95.3501 45.9352 95.1509 46.2383C94.9517 46.5416 94.6885 46.7987 94.3789 46.992C93.7685 47.3821 93.0741 47.6266 92.3509 47.7057C92.1333 47.7298 91.9173 47.7715 91.7061 47.8303C91.4821 48.4647 91.3917 49.1371 91.4389 49.8069C91.4861 50.4767 91.6717 51.1302 91.9829 51.7279C92.3173 52.1461 92.7437 52.484 93.2309 52.7156C93.7181 52.9473 94.2525 53.0666 94.7933 53.0648C95.7541 53.1167 96.7125 52.9173 97.5693 52.4869C98.4589 51.9579 99.2021 51.2226 99.7357 50.3456Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2485 53.0737L90.2349 53.6876L87.9165 54.5095",
    fill: "#C1813E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.241 27.23H24.4808L22.241 30.1015",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1553 27.23H44.6389L43.1458 30.1015",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4766 27.9478H85.7022L83.4622 30.1014",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2553 45.1768H24.4808L22.241 48.0483",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1553 45.1768H44.6389L43.1458 48.0483",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M63.304 45.1768H64.7972L63.304 48.0483",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2554 63.125H24.4808L22.241 65.9965",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4135 63.125H44.6389L42.3992 65.9965",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3135 63.125H64.7972L63.304 65.9965",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2554 81.0703H24.4808L22.241 83.9419",
    fill: "#AC41D8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4134 81.0703H44.6389L42.3992 83.9419",
    fill: "#AC41D8"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27475_40600",
    x1: 99.2082,
    y1: 43.0019,
    x2: 63.371,
    y2: 43.0019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_27475_40600",
    x1: 96.9608,
    y1: 49.1148,
    x2: 79.789,
    y2: 49.1148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_27475_40600",
    x1: 108.921,
    y1: 74.9442,
    x2: 54.4188,
    y2: 74.9442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27475_40600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.75)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgObra);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/obra.be5fde9bfa7fca9c20d002cd60fd7b1d.svg";